import { ChangeDetectionStrategy, Component } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-unsubscribe-thankyou',
  imports: [TranslocoModule, RmaIconComponent],
  templateUrl: './unsubscribe-thankyou.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope('unsubscribeFeedbackThankyou')],
})
export class UnsubscribeThankyouComponent {}
